(function () {
  // Drive prev/next disabled state from actual scroll position rather than
  // the slideshow's visibleSlides count, which can be stale (computed
  // synchronously before scroll animation completes) and produces false
  // "both disabled" states when all slides pass the 70% visibility threshold.
  /** @param {HTMLElement} slideshow */
  function syncButtons(slideshow) {
    var scroller = /** @type {HTMLElement | null} */ (slideshow.querySelector('slideshow-slides'));
    var nextBtn = /** @type {HTMLButtonElement | null} */ (slideshow.querySelector('[ref="next"]'));
    var prevBtn = /** @type {HTMLButtonElement | null} */ (
      slideshow.querySelector('[ref="previous"]')
    );
    if (!scroller || !nextBtn || !prevBtn) return;

    prevBtn.disabled = scroller.scrollLeft < 1;
    nextBtn.disabled = scroller.scrollLeft + scroller.offsetWidth >= scroller.scrollWidth - 1;
    syncArrowVisibility(slideshow);
  }

  /** @param {HTMLElement} slideshow */
  function syncArrowVisibility(slideshow) {
    var nextBtn = /** @type {HTMLButtonElement | null} */ (slideshow.querySelector('[ref="next"]'));
    var prevBtn = /** @type {HTMLButtonElement | null} */ (
      slideshow.querySelector('[ref="previous"]')
    );
    if (!nextBtn || !prevBtn) return;
    slideshow.classList.toggle('both-arrows-disabled', prevBtn.disabled && nextBtn.disabled);
  }

  /** @param {HTMLElement} slideshow */
  function updateOverflow(slideshow) {
    var scroller = /** @type {HTMLElement | null} */ (slideshow.querySelector('slideshow-slides'));
    if (!scroller) return;
    var overflows = scroller.scrollWidth > scroller.offsetWidth;
    slideshow.classList.toggle('has-overflow', overflows);
    if (overflows) {
      syncButtons(slideshow);
    } else {
      slideshow.classList.remove('both-arrows-disabled');
    }
  }

  /** @param {HTMLElement} slideshow */
  function initSlideshow(slideshow) {
    var scroller = /** @type {HTMLElement | null} */ (slideshow.querySelector('slideshow-slides'));

    updateOverflow(slideshow);

    // Re-sync on every scroll tick so buttons always reflect the real position,
    // even mid-animation when the slideshow's own setter may have set wrong states.
    if (scroller) {
      scroller.addEventListener(
        'scroll',
        function () {
          if (slideshow.classList.contains('has-overflow')) syncButtons(slideshow);
        },
        { passive: true },
      );
    }

    new ResizeObserver(function () {
      updateOverflow(slideshow);
    }).observe(slideshow);

    var pendingRecompute = false;
    new MutationObserver(function () {
      if (pendingRecompute) return;
      pendingRecompute = true;
      requestAnimationFrame(function () {
        pendingRecompute = false;
        updateOverflow(slideshow);
      });
    }).observe(slideshow, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.product-family-slideshow').forEach(initSlideshow);
    });
  } else {
    document.querySelectorAll('.product-family-slideshow').forEach(initSlideshow);
  }
})();
